// src/components/collapsible/recipe.ts
import { tv } from "tailwind-variants";
var collapsibleSlotRecipe = tv({
  slots: {
    root: [],
    trigger: [],
    content: [
      "overflow-hidden",
      "transition-all",
      "data-[state=closed]:animate-collapsible-up",
      "data-[state=open]:animate-collapsible-down"
    ]
  }
});

export {
  collapsibleSlotRecipe
};
